module.exports = __webpack_public_path__ + "static/media/mode-12.40420e44.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-12.svg
// module id = 985
// module chunks = 2